module.exports = __webpack_public_path__ + "static/media/image_4.277e88b5.jpg";